interface ProcessStepsProps {
  steps: { step: string; desc: string }[];
  title?: string;
}

export function ProcessSteps({ steps, title = "How It Works" }: ProcessStepsProps) {
  return (
    <section className="py-16 md:py-20 bg-secondary">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center">{title}</h2>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="relative flex flex-col items-center text-center px-4 py-6">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground text-sm font-bold shadow-md shadow-primary/15">
                {i + 1}
              </div>
              <h3 className="mt-4 text-[15px] font-bold text-foreground">{s.step}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
